import { useMemo } from 'react'
import { createOption } from 'transfix-ui/components/AutocompleteBase'
import { IFacilityLocation } from 'apps/fleet-planner/utils/autosuggest'
import { IOptionGroupIndex } from '../constants'

export const useDefaultValues = (valueProp?: IFacilityLocation) =>
  useMemo(() => {
    const { facility, location } = valueProp ?? {}
    if (facility) {
      const inputValue = facility.label
      const option = createOption({
        inputValue,
        dividerBefore: true,
        optionType: 'withIcon',
        iconName: 'LocationPinIcon',
        groupIndex: IOptionGroupIndex.Location,
        groupName: 'City or State',
        id: facility.id ?? '',
        text: inputValue,
      })

      return {
        defaultValue: option,
        defaultInputValue: inputValue,
      }
    }
    if (location) {
      const inputValue = location.label
      const option = createOption({
        inputValue,
        dividerBefore: true,
        optionType: 'withIcon',
        iconName: 'LocationPinIcon',
        groupIndex: IOptionGroupIndex.Location,
        groupName: 'City or State',
        id: location.id ?? '',
        text: inputValue,
      })

      return {
        defaultValue: option,
        defaultInputValue: inputValue,
      }
    }

    return {}
  }, [valueProp])
